import { render, staticRenderFns } from "./AuthorSearch.vue?vue&type=template&id=0437a28a"
import script from "./AuthorSearch.vue?vue&type=script&lang=js"
export * from "./AuthorSearch.vue?vue&type=script&lang=js"
import style0 from "./AuthorSearch.vue?vue&type=style&index=0&id=0437a28a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports